import Form from 'components/Form';

import { Grid, Typography } from '@mui/material';

import RowContainer from '../components/RowContainer';
import RowContent from '../components/RowContent';
import RowContentPre from './components/RowContent';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import { Stack } from '@mui/system';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const checks_ivf = [
  {
    label: '生理盐水',
    key: 'assessment_drips_ivf.checked1',
  },
  {
    label: '半生理盐水',
    key: 'assessment_drips_ivf.checked2',
  },
  {
    label: '5%葡萄糖半生理盐水',
    key: 'assessment_drips_ivf.checked3',
  },
  {
    label: '5%葡萄糖生理盐水',
    key: 'assessment_drips_ivf.checked4',
  },
  {
    label: '乳酸林格液',
    key: 'assessment_drips_ivf.checked5',
  },
  {
    label: '抗生素',
    key: 'assessment_drips_ivf.checked6',
  },
  {
    label: '等等',
    key: 'assessment_drips_ivf.checked7',
  },
];

const checks_drips = [
  {
    label: '肝素',
    key: 'assessment_drips_drips.checked1',
  },
  {
    label: '血液',
    key: 'assessment_drips_drips.checked2',
  },
  {
    label: '全胃肠外营养',
    key: 'assessment_drips_drips.checked3',
  },
  {
    label: '地尔硫卓',
    key: 'assessment_drips_drips.checked4',
  },
];

const checks_neuro = [
  {
    label: '清醒且定向',
    key: 'assessment_neuro.checked1',
  },
  {
    label: '困惑',
    key: 'assessment_neuro.checked2',
  },
];

const checks_neuro_activity = [
  {
    label: '自由活动',
    key: 'assessment_neuro_activity.checked1',
  },
  {
    label: '卧床休息',
    key: 'assessment_neuro_activity.checked2',
  },
  {
    label: '助行器',
    key: 'assessment_neuro_activity.checked3',
  },
  {
    label: '手杖',
    key: 'assessment_neuro_activity.checked4',
  },
  {
    label: '神经系统检查',
    key: 'assessment_neuro_activity.checked5',
  },
  {
    label: '约束',
    key: 'assessment_neuro_activity.checked6',
  },
  {
    label: '床位报警器',
    key: 'assessment_neuro_activity.checked7',
  },
];

const checks_res = [
  {
    label: '室内空气',
    key: 'assessment_res.checked1',
  },
  {
    label: '非循环呼吸面罩',
    key: 'assessment_res.checked2',
  },
  {
    label: '持续正压通气',
    key: 'assessment_res.checked3',
  },
  {
    label: '双水平正压通气',
    key: 'assessment_res.checked4',
  },
  {
    label: '氧气',
    key: 'assessment_res.checked5',
  },
];

const checks_res_sound = [
  {
    label: '清晰',
    key: 'assessment_res_input_sound.checked1',
  },
  {
    label: '减弱',
    key: 'assessment_res_input_sound.checked2',
  },
  {
    label: '喘鸣',
    key: 'assessment_res_input_sound.checked3',
  },
  {
    label: '啰音',
    key: 'assessment_res_input_sound.checked4',
  },
  {
    label: '粗糙',
    key: 'assessment_res_input_sound.checked5',
  },
];

const checks_res_treat = [
  {
    label: '雾化治疗',
    key: 'assessment_res_input_treat.checked1',
  },
  {
    label: '激励性肺活量计',
    key: 'assessment_res_input_treat.checked2',
  },
  {
    label: '胸部物理治疗',
    key: 'assessment_res_input_treat.checked3',
  },
];

const checks_res_cough = [
  {
    label: '有痰',
    key: 'assessment_res_input_cough.checked1',
  },
  {
    label: '无痰',
    key: 'assessment_res_input_cough.checked2',
  },
];

const Assessment2 = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <>
      <RowContainer
        xs={12}
        sx={{ margin: '20px auto 5px auto', marginLeft: '-25px' }}
      >
        <RowContentPre title="滴注，液体" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                静脉电解质
              </Typography>
            </Grid>
            {checks_ivf.map((v, i) => {
              return (
                <Grid item xs={i === 6 ? 0.5 : 1.6}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
            <Form.MuiTextField
              required={false}
              sx={{ width: '85px' }}
              disabled={disabled}
              placeholder="进入"
              {...register('assessment_drips_ivf_input')}
            />
          </Stack>
        </RowContentPre>
        <RowContent title="" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                静脉滴速
              </Typography>
            </Grid>
            <Grid item xs={2.7}>
              <Stack direction="row" spacing={3}>
                <Form.MuiTextField
                  required={false}
                  sx={{ width: '190px' }}
                  disabled={disabled}
                  InputProps={{ ...Form.adornment('#', '') }}
                  {...register('assessment_drips_iv_input')}
                />
                <Form.MuiTextField
                  required={false}
                  sx={{ width: '190px' }}
                  disabled={disabled}
                  placeholder="进入"
                  InputProps={{ ...Form.adornment('', 'u/kg/hr') }}
                  {...register('assessment_drips_iv_date')}
                />
              </Stack>
            </Grid>
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                滴注
              </Typography>
            </Grid>
            {checks_drips.map((v, i) => {
              return (
                <Grid item xs={i === 6 ? 0.5 : 1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="神经系统" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            {checks_neuro.map((v, i) => {
              if (i === 0) {
                return (
                  <Grid item xs={2.9}>
                    <Stack direction="row">
                      <Form.MuiCheckbox
                        label={v.label}
                        disabled={disabled}
                        defaultValue={
                          Boolean(getValues(v.key)) ? [v.label] : []
                        }
                        onChange={(_, checked) => {
                          setValue(v.key, checked);
                        }}
                      />
                      <Form.MuiTextField
                        required={false}
                        sx={{ width: '150px', marginLeft: '20px' }}
                        disabled={disabled}
                        placeholder="进入"
                        {...register('assessment_neuro_input')}
                      />
                    </Stack>
                  </Grid>
                );
              }
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                活动
              </Typography>
            </Grid>
            {checks_neuro_activity.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="疼痛" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                程度
              </Typography>
            </Grid>

            <Grid item xs={2.9}>
              <Stack direction="row">
                <Form.MuiTextField
                  required={false}
                  disabled={disabled}
                  placeholder="进入"
                  {...register('assessment_pain_input1')}
                />
              </Stack>
            </Grid>
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                位置
              </Typography>
            </Grid>

            <Grid item xs={2.9}>
              <Stack direction="row">
                <Form.MuiTextField
                  required={false}
                  disabled={disabled}
                  placeholder="进入"
                  {...register('assessment_pain_input2')}
                />
              </Stack>
            </Grid>
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                药物
              </Typography>
            </Grid>

            <Grid item xs={2.9}>
              <Stack direction="row">
                <Form.MuiTextField
                  required={false}
                  disabled={disabled}
                  placeholder="进入"
                  {...register('assessment_pain_input3')}
                />
              </Stack>
            </Grid>
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                频率
              </Typography>
            </Grid>

            <Grid item xs={2.9}>
              <Stack direction="row">
                <Form.MuiTextField
                  required={false}
                  disabled={disabled}
                  placeholder="进入"
                  {...register('assessment_pain_input4')}
                />
              </Stack>
            </Grid>
          </Stack>
        </RowContent>
        <RowContent title="呼吸系统" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            {checks_res.map((v, i) => {
              return (
                <Grid item xs={i === 4 ? 0.5 : 1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckboxSubSup
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
            <Form.MuiTextField
              required={false}
              sx={{ width: '95px', marginLeft: '20px' }}
              disabled={disabled}
              placeholder="进入"
              InputProps={{ ...Form.adornment('', 'L') }}
              {...register('assessment_res_input')}
            />
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                气管造口
              </Typography>
            </Grid>
            <Grid item xs={2.9}>
              <Stack direction="row">
                <Form.MuiTextField
                  required={false}
                  disabled={disabled}
                  placeholder="进入"
                  {...register('assessment_res_input_trach')}
                />
              </Stack>
            </Grid>
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                呼吸音
              </Typography>
            </Grid>
            {checks_res_sound.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                治疗
              </Typography>
            </Grid>
            {checks_res_treat.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={1.4}>
              <Typography
                variant="caption"
                fontWeight={400}
                lineHeight="38px"
                sx={{ whiteSpace: 'nowrap' }}
              >
                咳嗽
              </Typography>
            </Grid>
            {checks_res_cough.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
      </RowContainer>
    </>
  );
};

export default Assessment2;
